import React from "react";
import { camelCase } from "../../utils/constant";
import { BackIcon } from "../Icons/BackIcon";
import { Avatar, Badge, Space } from "antd";

const ViewUserDetails = ({ user, setShowUserDetails }) => {
  const myPreferences = user?.preferences;
  const profile_pic = !user?.profile_pic
    ? "https://robohash.org/hicveldicta.png"
    : user?.profile_pic;

  const showPreferences =
    myPreferences && Object.keys(myPreferences).length > 0;
  console.log("myPreferences", myPreferences);
  return (
    <>
      <div className="Container">
        <div>
          <div className="titlediv flex justify-between pt-[10px] pb-[30px]">
            <Space>
              <BackIcon
                onClick={() => setShowUserDetails(false)}
                className="cursor-pointer hover:text-[blue]"
              />

              <div className="flex justify-between text-gray-700 font-baijamjuree text-[22px] font-semibold leading-6">
                Customer Profile
              </div>
            </Space>
          </div>
          <div
            className="drop-shadow-custom w-full md:pl-0"
            bordered={false}
            size="default"
          >
            <div className="flex flex-col md:flex-row">
              <div className="mb-4 md:mb-0 md:mr-6">
                <Avatar shape="square" size={100} src={profile_pic} />
              </div>
              <div className="w-full">
                <div className="detailsGrid grid grid-cols-2 gap-4">
                <div className="flex flex-col">
                    <div className="py-[15px]">
                      <div className=" font-bold text-[#333333] text-base">
                        First Name
                      </div>
                      <div className=" font-medium text-gray-500 text-base">
                        {!user?.first_name ? "-" : user?.first_name}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="py-[15px]">
                      <div className=" font-bold text-[#333333] text-base">
                        Last Name
                      </div>
                      <div className=" font-medium text-gray-500 text-base">
                        {!user?.last_name ? "-" : user?.last_name}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="py-[15px]">
                      <div className=" font-bold text-[#333333] text-base">
                        Email
                      </div>
                      <div className=" font-medium text-gray-500 text-base">
                        {!user?.email ? "-" : user?.email}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="py-[15px]">
                      <div className=" font-bold text-[#333333] text-base">
                        Phone Number
                      </div>
                      <div className="font-medium text-gray-500 text-base">
                        {user?.phone_number && user?.country_code
                          ? `${user?.country_code} ${user?.phone_number}`
                          : "-"}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <div className="py-[15px]">
                      <div className=" font-bold text-[#333333] text-base">
                        Address
                      </div>
                      <div className=" font-medium text-gray-500 text-base">
                        {!user?.address ? "-" : user?.address}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPreferences && (
        <div className="Container mt-[15px]">
          <div>
            <div className="titlediv flex justify-between pt-[10px] pb-[30px]">
              <div className="flex justify-between text-gray-700 font-baijamjuree text-[22px] font-semibold leading-6">
                My Preferences
              </div>
            </div>
            <div
              className="drop-shadow-custom w-full md:pl-0"
              bordered={false}
              size="default"
            >
              {myPreferences &&
                Object.entries(myPreferences)
                  .filter(([_, options]) => options.length > 0) // Filter out categories with empty arrays
                  .map(([category, options], index) => (
                    <div key={index}>
                      <span className="text-[14px] font-semibold text-[#333] max-w-[700px] leading-[17.64px] not-italic capitalize pb-1 border-b border-[blue]">
                        {category.replace(/_/g, " ")}
                      </span>
                      <div className="grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3 py-[10px] gap-2 pl-[15px]">
                        {options.map((option, index) => (
                          <span
                            key={index}
                            className="font-normal text-[13px] md:text-[14px] leading-[27.49px] text-[#1D1D1D] capitalize !min-w-[48%] max-w-fit"
                          >
                            <Badge
                              color={"blue"}
                              text={option.label?.replace(/_/g, " ")}
                            />
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewUserDetails;
